// extracted by mini-css-extract-plugin
export default {"div":"Suppliers_div__7abLr","scroll":"Suppliers_scroll__-7yIF","table":"Suppliers_table__d2ylO","th":"Suppliers_th__2EmeS","td":"Suppliers_td__0Trsz","tr":"Suppliers_tr__uU1AC"};